import VerticalProQuestionAndAnswers, {
  convertJobTypeDataToLocale,
  VerticalProQuestionAndAnswersProps,
} from './VerticalProQuestionAndAnswers';

export { convertJobTypeDataToLocale };
export type { VerticalProQuestionAndAnswersProps };
export default VerticalProQuestionAndAnswers;
